/**
 * Created by lu on 2017/12/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.model.List,
    method: {
        init: function () {
            this.set('itemType', require('../../view/uploadImg/ImgItem'));
            this.set('itemModelType', require('./ImgItem'));
        }
        // getItemType:function (index,item) {
        //     if(item.get('index')==='last'){
        //         return require('../view/AddPic');
        //     }else{
        //         return require('../view/ImgItem')
        //     }
        // }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/uploadImg/ImgList.js
// module id = 87
// module chunks = 3 4 8 19 29